import * as React from "react";
// import { Logout } from '@mui/icons-material';
import {
  // AppBar,
  // Toolbar,
  Typography,
  Box,
  Grid,
  Button,
  Paper,
  Stack,
  IconButton,
  Divider,
  Chip,
} from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import Logout from "@mui/icons-material/Logout";

// ✅ Highlight “más usado” (opcional). Si es null, usa el primero.
const MOST_USED_SPACE_ID = null; // ej: "P1"

export default function Espacios({ espacios, changeTitle, changeConBack, onSelectSpace }) {
  const PAGE_SIZE = 9;
  const COLUMNS = 3;
  const SWIPE_THRESHOLD = 70; // px

  const [page, setPage] = React.useState(0);

  // ✅ animación de cambio de página
  const [slide, setSlide] = React.useState({ dir: "next", key: 0 }); // dir: "next" | "prev"

  const totalPages = Math.max(1, Math.ceil(espacios.length / PAGE_SIZE));
  const safePage = Math.min(page, totalPages - 1);

  React.useEffect(() => {
    if (page !== safePage) setPage(safePage);
  }, [page, safePage]);

  const start = safePage * PAGE_SIZE;
  const current = espacios.slice(start, start + PAGE_SIZE);

  const mostUsedId = MOST_USED_SPACE_ID || (espacios[0]?.id ?? null);

  const handleSelect = (spaceId) => {
    if (typeof onSelectSpace === "function") onSelectSpace(spaceId);
    else console.log("Selected space:", spaceId);
  };

  const triggerSlide = (dir) => {
    setSlide((s) => ({ dir, key: s.key + 1 }));
  };

  const handlePrev = () => {
    if (safePage <= 0) return;
    triggerSlide("prev");
    setPage(safePage - 1);
  };

  const handleNext = () => {
    if (safePage >= totalPages - 1) return;
    triggerSlide("next");
    setPage(safePage + 1);
  };

  // --- swipe ---
  const swipeRef = React.useRef({ active: false, startX: 0, startY: 0 });

  const onTouchStart = (e) => {
    if (totalPages <= 1) return;
    const t = e.touches?.[0];
    if (!t) return;
    swipeRef.current.active = true;
    swipeRef.current.startX = t.clientX;
    swipeRef.current.startY = t.clientY;
  };

  const onTouchEnd = (e) => {
    if (totalPages <= 1) return;
    if (!swipeRef.current.active) return;

    swipeRef.current.active = false;
    const t = e.changedTouches?.[0];
    if (!t) return;

    const dx = t.clientX - swipeRef.current.startX;
    const dy = t.clientY - swipeRef.current.startY;

    // ignorar si fue mayormente vertical
    if (Math.abs(dy) > Math.abs(dx) * 0.6) return;

    // swipe izquierda => next
    if (dx <= -SWIPE_THRESHOLD) handleNext();

    // swipe derecha => prev
    if (dx >= SWIPE_THRESHOLD) handlePrev();
  };

  React.useEffect(() => {
    changeTitle('Selección de Espacio');
    changeConBack(false);
  }, []);

  // return (
    // <Box sx={{ height: "100vh", display: "flex", flexDirection: "column" }}>
/*
       <AppBar
        position="static"
        color="default"
        elevation={0}
        sx={{ borderBottom: 1, borderColor: "divider" }}
      >
 */
/*
    <Toolbar sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
      <Typography variant="h6">Seleccionar espacio</Typography>
       */
{/*
          {totalPages > 1 && (
            <Stack direction="row" alignItems="center" spacing={1}>
              <IconButton onClick={handlePrev} disabled={safePage === 0} aria-label="Página anterior">
                <ChevronLeftIcon />
              </IconButton>

              <Typography variant="body2" sx={{ minWidth: 110, textAlign: "center" }}>
                Página {safePage + 1} de {totalPages}
              </Typography>

              <IconButton
                onClick={handleNext}
                disabled={safePage === totalPages - 1}
                aria-label="Página siguiente"
              >
                <ChevronRightIcon />
              </IconButton>
            </Stack>
          )}
 */}
    /*
          <IconButton aria-label="logout">
            <Logout />
          </IconButton>
        </Toolbar>
      </AppBar>
 */
  return (
      <Box sx={{ flex: 1, p: 2, display: "flex" }} onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>
        <Paper
          variant="outlined"
          sx={{
            flex: 1,
            p: 2,
            borderRadius: 2,
            display: "flex",
            flexDirection: "column",
            gap: 2,
            bgcolor: "background.paper",
          }}
        >
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="body2" color="text.secondary">
              Elegí un espacio para abrir su mapa
            </Typography>

            {totalPages > 1 && (
              <Typography variant="caption" color="text.secondary">
                Tip: deslizá para cambiar de página
              </Typography>
            )}
          </Stack>

          <Divider />

          {/* ✅ Wrapper con animación al cambiar de página */}
          <Box
            key={slide.key}
            sx={{
              flex: 1,
              animation: `${slide.dir === "next" ? "slideInNext" : "slideInPrev"} 220ms ease-out`,
              "@keyframes slideInNext": {
                "0%": { transform: "translateX(100%)", opacity: 1 },
                "100%": { transform: "translateX(0)", opacity: 1 },
              },
              "@keyframes slideInPrev": {
                "0%": { transform: "translateX(-100%)", opacity: 1 },
                "100%": { transform: "translateX(0)", opacity: 1 },
              },
            }}
          >
            <Grid container spacing={2} sx={{ flex: 1, alignContent: "flex-start" }}>
              {current.map((space) => {
                const isMostUsed = mostUsedId && space.id === mostUsedId;

                return (
                  <Grid key={space.id} item size={{ xs: 12, sm: 4 }}>
                    <Button
                      fullWidth
                      size="large"
                      variant="contained"
                      onClick={() => handleSelect(space.id)}
                      sx={{
                        height: "20vh",
                        minHeight: '100px',
                        borderRadius: 2,
                        textTransform: "none",
                        alignItems: "stretch",
                        justifyContent: "flex-start",
                        px: 2,
                        py: 1.5,
                        ...(isMostUsed
                          ? {
                              boxShadow: 6,
                              outline: "2px solid",
                              outlineColor: "primary.main",
                              outlineOffset: "2px",
                            }
                          : null),
                      }}
                    >
                      <Stack spacing={0.75} sx={{ width: "100%", textAlign: "left" }}>
                        <Stack direction="row" justifyContent="space-between" alignItems="center" gap={1}>
                          <Typography variant="subtitle1" sx={{ fontWeight: 800 }} noWrap>
                            {space.nombre}
                          </Typography>
                          {isMostUsed && <Chip size="small" label="Más usado" variant="outlined" />}
                        </Stack>

                        {space.subtitle && (
                          <Typography variant="body2" sx={{ opacity: 0.9 }} noWrap>
                            {space.subtitle}
                          </Typography>
                        )}
                      </Stack>
                    </Button>
                  </Grid>
                );
              })}
            </Grid>
          </Box>

          {totalPages > 1 && (
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Button variant="outlined" onClick={handlePrev} disabled={safePage === 0} startIcon={<ChevronLeftIcon />}>
                Anterior
              </Button>

              <Typography variant="body2" color="text.secondary">
                {safePage + 1} / {totalPages}
              </Typography>

              <Button
                variant="outlined"
                onClick={handleNext}
                disabled={safePage === totalPages - 1}
                endIcon={<ChevronRightIcon />}
              >
                Siguiente
              </Button>
            </Stack>
          )}
        </Paper>
      </Box>
    // </Box>
  );
}
